import { MultiSelect as MantineMultiSelect } from '@mantine/core'
import { useState } from 'react'

import { Icon, IconProps } from '@percent/lemonade'

export function MultiSelect({ value, setFieldValue, options, onChangeFieldName, placeholder, searchable = true }) {
  const [selectIcon, setSelectIcon] = useState<{
    activitiesDropdownIcon: IconProps['name']
    skillsDropdownIcon: IconProps['name']
  }>({
    activitiesDropdownIcon: 'dropdown-arrow-down',
    skillsDropdownIcon: 'dropdown-arrow-down'
  })

  return (
    <MantineMultiSelect
      style={{ width: '100%' }}
      placeholder={!value.length ? placeholder : ''}
      searchable={searchable}
      data={options}
      value={value}
      onChange={selectedValues => setFieldValue(onChangeFieldName, selectedValues)}
      rightSection={<Icon name={selectIcon.skillsDropdownIcon} size={8} color="gray600" />}
      onDropdownOpen={() => {
        setSelectIcon({ ...selectIcon, skillsDropdownIcon: 'dropdown-arrow-up' })
      }}
      onDropdownClose={() => {
        setSelectIcon({ ...selectIcon, skillsDropdownIcon: 'dropdown-arrow-down' })
      }}
      comboboxProps={{ withinPortal: false }}
      styles={{
        pill: {
          borderRadius: 4
        }
      }}
    />
  )
}
